export class CurrencyPair {
  baseCcy: string;
  termCcy: string;

  constructor(baseCcy: string, termCcy: string) {
    this.baseCcy = baseCcy;
    this.termCcy = termCcy;
  }
}
